import { render, staticRenderFns } from "./DownloadMobileApp.vue?vue&type=template&id=84cf7026&scoped=true&"
import script from "./DownloadMobileApp.vue?vue&type=script&lang=js&"
export * from "./DownloadMobileApp.vue?vue&type=script&lang=js&"
import style0 from "./DownloadMobileApp.vue?vue&type=style&index=0&id=84cf7026&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84cf7026",
  null
  
)

export default component.exports